
import { useState, useRef } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

const ImageGallery = ({ images, title = "" }) => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const scrollContainerRef = useRef(null);

  if (!images || images.length === 0) {
    return (
      <div className="bg-white rounded-xl overflow-hidden  shadow-sm">
        <div className="relative aspect-video bg-gray-200 flex items-center justify-center">
          <p className="text-gray-500">No images available</p>
        </div>
      </div>
    );
  }

  const scroll = (direction) => {
    if (scrollContainerRef.current) {
      const scrollAmount = 200;
      scrollContainerRef.current.scrollBy({
        left: direction === "left" ? -scrollAmount : scrollAmount,
        behavior: "smooth",
      });
    }
  };

  return (
    <div className="bg-white rounded-xl overflow-hidden  shadow-sm">
      <div className="relative aspect-video">
        <img
          src={images[currentImageIndex]?.url}
          alt={title}
          className="w-full h-full object-cover"
        />
      </div>

      {/* Thumbnail Gallery - Scrollable */}
      {images.length > 1 && (
        <div className="relative p-3">
          <div
            ref={scrollContainerRef}
            className="flex gap-2 overflow-x-auto scrollbar-hide"
            style={{ scrollbarWidth: "none"}}
          >
            {images.map((img, idx) => (
              <button
                key={img._id || idx}
                onClick={() => setCurrentImageIndex(idx)}
                className={`flex-shrink-0 w-20 h-16 sm:w-24 sm:h-20 rounded-lg overflow-hidden border-2 transition-all ${
                  currentImageIndex === idx
                    ? "border-blue-600"
                    : "border-gray-200 hover:border-gray-400"
                }`}
              >
                <img
                  src={img.url}
                  alt={`View ${idx + 1}`}
                  className="w-full h-full object-cover"
                />
              </button>
            ))}
          </div>

          {/* Left Arrow */}
          <button
            onClick={() => scroll("left")}
            className="absolute left-0 top-1/2 -translate-y-1/2 bg-white/80 hover:bg-white/95 rounded-full p-1.5 shadow-md transition-all ml-1"
          >
            <ChevronLeft className="w-5 h-5 text-gray-700" />
          </button>

          {/* Right Arrow */}
          <button
            onClick={() => scroll("right")}
            className="absolute right-0 top-1/2 -translate-y-1/2 bg-white/80 hover:bg-white/95 rounded-full p-1.5 shadow-md transition-all mr-1"
          >
            <ChevronRight className="w-5 h-5 text-gray-700" />
          </button>
        </div>
      )}
    </div>
  );
};
export default ImageGallery;
